export default __webpack_public_path__ + "static/media/6-Sevan-Kan du uttrykke ulike sider ved din identitet i Norge.3715d1d6.mp4";